module.exports = __webpack_public_path__ + "static/media/Ship-Meraviglia-MSC_YC.d76387e3.jpg";